const blockedCollections: string[] = [
  '0x6d5087B3082f73D42a32D85e38BC95dcceDe39Bb', // Avax apes
].map((address) => address.toLowerCase());

export default blockedCollections;
